import React from 'react';
import { LinkCell } from '@hud/web-components/Table/Table';
import { CellContext } from '@tanstack/react-table';
import { BreadcrumbItem } from '@hud/web-components/Breadcrumbs/Breadcrumbs';
import LongContentPopover from '@hud/web-components/LongContentPopover/LongContentPopover';
import { Job, JobEndpoint } from '@hud/portal-dtos/pr-comparisons.dto';
import { EntityReference } from '@hud/portal-dtos/webapp-common.dto';
import { useFiltersForFunction } from '../../hooks/useFiltersForFunction';

export default function renderEndpointByPath<TData extends JobEndpoint>(
  referralBreadcrumbs?: BreadcrumbItem[] | null,
  tags?: Record<string, string>,
) {
  return function CellRenderer(cell: CellContext<TData, string>) {
    const row = cell.row.original;
    const updatedFilters = useFiltersForFunction(undefined, undefined, tags);
    const urlParams = new URLSearchParams(updatedFilters);
    urlParams.set('environment', 'ci');
    return (
      <LongContentPopover>
        <LinkCell
          to={`/explore/endpoints/${row.id}-${row.serviceId}?${urlParams.toString()}`}
          state={{ referralBreadcrumbs: referralBreadcrumbs }}
        >
          {cell.getValue()}
        </LinkCell>
      </LongContentPopover>
    );
  };
}

export function renderEndpointByPathAndJob<TData extends Job, TValue extends EntityReference>(
  referralBreadcrumbs?: BreadcrumbItem[] | null,
) {
  return function CellRenderer(cell: CellContext<TData, TValue>) {
    const row = cell.row.original;
    const epAndService = `${row.topDegradedEndpoint?.id}-${row.topDegradedEndpointService?.id}`;
    const tags = { job: row.id };
    const updatedFilters = useFiltersForFunction(undefined, undefined, tags);
    const urlParams = new URLSearchParams(updatedFilters);
    urlParams.set('environment', 'ci');
    return (
      <LongContentPopover>
        <LinkCell
          to={`/explore/endpoints/${epAndService}?${urlParams.toString()}`}
          state={{ referralBreadcrumbs: referralBreadcrumbs }}
        >
          {cell.getValue()?.name}
        </LinkCell>
      </LongContentPopover>
    );
  };
}
